export default __webpack_public_path__ + "static/media/the-waves-book-s.df7d337f.webp";